<template>
<v-container>
    <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
            <span class="text-h6 font-weight-bold">Журнал выгруженных отчеты</span>
            <v-divider class="my-2" />
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12">
            <v-row class="mt-2">
                <v-col cols="6">
                    <v-menu ref="menu" v-model="fromMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="fromDate1" label="Период от:" hint="ГГГГ-ММ-ДД" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="fromDate" no-title @input="fromMenu = false" locale="ru-Ru"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6">
                    <v-menu ref="menu" v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="toDate1" label="Период до:" hint="ГГГГ-ММ-ДД" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="toDate" no-title @input="toMenu = false" locale="ru-Ru"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-divider class="my-3" />
            <v-data-table :headers="headers" :items="
            userReportCountByPeriod != null ? userReportCountByPeriod.items : []" :items-per-page="20" class="elevation-2" hide-default-footer :loading="loading" loading-text="Идет загрузка... Пожалуйста подождите">
                <template slot="progress">
                    <v-progress-linear color="blue-grey darken-1" indeterminate></v-progress-linear>
                </template>
                <template v-slot:item.info="{ item }">
                    <v-btn small fab text @click="viewUserReports(item.userId)">
                        <v-icon color="blue-grey darken-1">mdi-location-enter</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <v-card elevation="1">
                <v-card-text class="py-0">
                    <v-pagination v-model="currentPage" :length="totalPages" color="blue-grey darken-1"></v-pagination>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <v-dialog v-model="dialog.show" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark :color="dialog.color" elevation="0">
                <v-toolbar-title>{{dialog.title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click="dialog.show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <user-reports-by-user-id :dateStart="fromDate" :dateEnd="toDate" :userId="selectedUserId" :key="selectedUserId" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import UserReportsByUserId from './UserReportsByUserId.vue';
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
    name: "ReportUnload",
    components: {
        UserReportsByUserId
    },
    data: () => ({
        headers: [{
                text: "Пользователь",
                sortable: false,
                align: "center",
                value: "userName",
            },
            {
                text: "Количество сформированных отчетов",
                sortable: false,
                align: "center",
                value: "reportsCount",
            },
            {
                text: "Действия",
                sortable: false,
                align: "center",
                value: "info",
            },
        ],
        currentPage: 1,
        totalPages: 1,
        fromMenu: false,
        toMenu: false,
        fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        fromDate1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        toDate1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        loading: true,
        dialog: {
            show: false,
            title: 'Информация',
            color: 'blue-grey darken-1',
        },
        selectedUserId: null
    }),
    computed: {
        ...mapGetters({
            getUserReportCountByPeriod: "unload/GET_USER_REPORT_COUNT_BY_PERIOD",
        }),
        userReportCountByPeriod() {
            return this.getUserReportCountByPeriod;
        },
    },
    methods: {
        ...mapActions({
            generateUserReportCountByPeriod: "unload/GENERATE_USER_REPORT_COUNT_BY_PERIOD",
        }),
        async getUserReportCountByPeriodFromAPI(isNewPage = true) {
            await this.generateUserReportCountByPeriod({
                pageNumber: this.currentPage,
                pageSize: 20,
                dateStart: this.fromDate,
                dateEnd: this.toDate,
            });
            if (!isNewPage) {
                this.totalPages = this.userReportCountByPeriod.totalPages;
                this.currentPage = this.userReportCountByPeriod.pageNumber;
            }
        },
        setLoading(state) {
            this.loading = state;
        },
        viewUserReports(userId) {
            this.selectedUserId = userId;
            this.dialog.show = true;
        }
    },
    watch: {
        currentPage: function () {
            this.setLoading(true);
            this.getUserReportCountByPeriodFromAPI();
            this.setLoading(false);
        },
        fromDate: function () {
            this.setLoading(true);
            this.fromDate1 = this.fromDate;
            this.getUserReportCountByPeriodFromAPI(false);
            this.setLoading(false);
        },
        toDate: function () {
            this.setLoading(true);
            this.toDate1 = this.toDate;
            this.getUserReportCountByPeriodFromAPI(false);
            this.setLoading(false);
        },
    },
    async created() {
        this.setLoading(true);
        await this.getUserReportCountByPeriodFromAPI(false);
        this.setLoading(false);
    },
};
</script>
